module.exports = __webpack_public_path__ + "static/media/signage-indoor-img41.45cd4ab1.jpg";